import { Directive, forwardRef, Attribute } from '@angular/core';
import { AbstractControl, Validator, NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[appValidMonth][formControlName],[appValidMonth][formControl],[appValidMonth][ngModel]',
  providers: [{provide: NG_VALIDATORS, multi: true, useExisting: forwardRef(() => ValidMonthDirective)}]
})
export class ValidMonthDirective {

  constructor() { }

validate(input: AbstractControl):{[key: string]:any} {

	let v = input.value;

	if (v !== "0") {
		return null;
    }else{
    	return {appValidJobType: false};
    }

}

}
